import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function ProductReviews({ dataBvShow }) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    reviewData,
  } = ProductPageState;

  return (
    <div className="product-rating-container" data-testid="product-rating-container">
      <div data-bv-show={dataBvShow} data-bv-product-id={reviewData?.reviewsSku} />
    </div>
  );
}
